import { GuaranteeDto } from "api/pricing";
import { ConfigGarantieItemDto } from "api/real-estate";

import { GuaranteesReferential } from "../../../types/interfaces";

/**
 * Convertit la couverture persistée d'un parc (niveau garantie-produit : actif + franchise/plafond)
 * en sélection de garanties (GuaranteeDto avec valeurs), en s'appuyant sur le référentiel courant.
 * Les obligatoires sont toujours retenues ; les optionnelles seulement si actives dans la config.
 */
export const buildSelectionFromConfigItems = (
  items: ConfigGarantieItemDto[] | undefined,
  referential: GuaranteesReferential
): GuaranteesReferential => {
  const byId = new Map((items ?? []).map((i) => [i.garantieId, i]));

  const withValues = (g: GuaranteeDto): GuaranteeDto => {
    const i = byId.get(g.id);
    return {
      ...g,
      deductible: g.deductible ? { ...g.deductible, value: i?.franchise ?? g.deductible.value } : g.deductible,
      ceiling: g.ceiling ? { ...g.ceiling, value: i?.plafond ?? g.ceiling.value } : g.ceiling,
    };
  };

  return {
    mandatory: referential.mandatory.map(withValues),
    optional: referential.optional.filter((g) => byId.get(g.id)?.active).map(withValues),
  };
};
